import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { MiterPosition } from "./LineMiterRender";

const updateRingForRightMiter = (ring: Coordinates[], miterSize: number, isLastRing: boolean): Coordinates[] => {
  const reversedRing = ring.slice().reverse();

  for (let i = 0; i < reversedRing.length; i++) {
    const coordinates = reversedRing[i];

    if (isLastRing && i === 0) {
      reversedRing[i] = [coordinates[0] - miterSize, coordinates[1]];
    }

    const nextCoordinates = reversedRing[i - 1];

    if (nextCoordinates && nextCoordinates[0] < coordinates[0]) {
      reversedRing[i] = [nextCoordinates[0] - Math.abs(nextCoordinates[0] - coordinates[0]), coordinates[1]];
    }
  }

  return reversedRing.reverse();
};

const updateRingForLeftMiter = (ring: Coordinates[], miterSize: number, isFirstRing: boolean): Coordinates[] => {
  const newRing = ring.slice();

  for (let i = 0; i < newRing.length; i++) {
    const coordinates = newRing[i];

    if (i === 0 && isFirstRing) {
      newRing[i] = [coordinates[0] + miterSize, coordinates[1]];
    }

    const prevCoordinates = newRing[i - 1];

    if (prevCoordinates && prevCoordinates[0] > coordinates[0]) {
      newRing[i] = [prevCoordinates[0] + Math.abs(coordinates[0] - prevCoordinates[0]), coordinates[1]];
    }
  }

  return newRing;
};

export const updateRingsForMiter = (
  rings: Coordinates[][],
  position: MiterPosition,
  miterSize: number,
): Coordinates[][] => {
  return rings.map((ring, ringIndex) => {
    switch (position) {
      case "right":
        return updateRingForRightMiter(ring, miterSize, ringIndex === rings.length - 1);
      default:
        return updateRingForLeftMiter(ring, miterSize, ringIndex === 0);
    }
  });
};
